import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Box, Stack } from '@mui/material';
import APIService from 'src/utils/APIService';
import {
  TRIGGER_TITLE_DESTINATION_RESULT_COLUMNS,
  TRIGGER_TITLE_RESULT_CHILD_COLUMNS,
} from 'src/constants/dataGridColumns';
import ORMDataGridV2 from 'src/components/Shared/Table/ORMDataGridV2';

const TriggerTitlesChildTable = ({ id }) => {
  const [state, setState] = useState({ error: false, data: [], isLoading: true });
  const [detailPanelExpandedRowIds, setDetailPanelExpandedRowIds] = useState([]);
  const [gridKey, setGridKey] = useState(0);

  const dataGridRef = useRef();
  const fetchData = useCallback(async () => {
    const response = await APIService.get(`/triggertitle/result/destination-info/${id}`);
    const { status, data } = response || {};
    if (status === 200) {
      setState({ data: data, error: false, isLoading: false });
    } else {
      setState({ data: [], error: true, isLoading: false });
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const { error, data, isLoading } = state;

  if (isLoading) {
    return 'Loading.........';
  }
  if (data?.length === 0) {
    return 'No Data Found';
  }
  if (error) {
    return 'Something went wrong!';
  }

  const getDetailPanelContent = ({ row }) => {
    if (detailPanelExpandedRowIds?.includes(row.campaignId)) {
      return (
        <Box sx={{ p: 2 }}>
          <ORMDataGridV2
            isDefaultCompact={true}
            columns={TRIGGER_TITLE_RESULT_CHILD_COLUMNS}
            rows={row?.titles || []}
            toolbarOptions={['SEARCH']}
            uniqueRowId='primary_isbn'
            singleLineHeader
            height='auto'
            variant='primary'
            pagination
            pageSizeOptions={[10, 25, 50, 100]}
            defaultPagination={{ pageSize: 10, page: 0 }}
          />
        </Box>
      );
    } else {
      return <></>;
    }
  };

  return (
    <Stack sx={{ mx: 2, py: 2, height: '100%', boxSizing: 'border-box' }}>
      <ORMDataGridV2
        key={gridKey}
        columns={TRIGGER_TITLE_DESTINATION_RESULT_COLUMNS}
        rows={data}
        uniqueRowId='campaignId'
        ref={dataGridRef}
        variant='secondary'
        singleLineHeader
        height='auto'
        showToolbar={false}
        getDetailPanelContent={getDetailPanelContent}
        detailPanelExpandedRowIds={detailPanelExpandedRowIds || []}
        onDetailPanelExpandedRowIdsChange={newIds => {
          setDetailPanelExpandedRowIds(Array.from(newIds));
          requestAnimationFrame(() => {
            // fallback — force layout with key remount
            setGridKey(prev => prev + 1);
          });
        }}
      ></ORMDataGridV2>
    </Stack>
  );
};

export default React.memo(TriggerTitlesChildTable);
